import * as React from "react";
import {
  BookOpen,
  Bot,
  Trophy,
  List,
  Calendar,
  SquareTerminal,
  DollarSign,
  Wallet,
} from "lucide-react";

import { AdminNav } from "~/components/admin-nav";
import { NavProjects } from "~/components/nav-projects";
import { TeamSwitcher } from "~/components/team-switcher";
import {
  Sidebar,
  SidebarContent,
  SidebarRail,
  SidebarHeader,
  SidebarFooter,
} from "~/components/ui/sidebar";
import { AuthenticatedUser } from "~/models/auth";
import { UnauthUser } from "~/components/unauthUser";
import { NavUser } from "~/components/nav-user";
import { AppVersion } from "~/components/app-version";

// This is sample data.
const data = {
  navMain: [
    {
      title: "Leagues",
      url: "",
      icon: Bot,
      items: [
        {
          title: "Quick Create",
          url: "/admin/league/quick-create",
        },
        {
          title: "Advanced Create",
          url: "/admin/league/create",
        },
        {
          title: "View all leagues",
          url: "/admin/leagues",
        },
      ],
    },
    {
      title: "Users",
      url: "",
      icon: BookOpen,
      items: [
        {
          title: "User lookup",
          url: "/admin/users",
        },
      ],
    },
    {
      title: "Ledger",
      url: "",
      icon: List,
      items: [
        {
          title: "Ledger Management",
          url: "/admin/ledger",
        },
        {
          title: "Operator Wallet",
          url: "/admin/operator-wallet",
        },
      ],
    },
  ],
  projects: [
    {
      name: "Home",
      url: "/",
      icon: Calendar,
    },
    {
      name: "My Wallet",
      url: "/wallet",
      icon: Wallet,
    },
    // {
    //   name: "Results",
    //   url: "/results",
    //   icon: Trophy,
    // },
    //
    // {
    //   name: "My Leagues",
    //   url: "/user/leagues",
    //   icon: List,
    // },
  ],
};

export function AppSidebar({
  ...props
}: React.ComponentProps<typeof Sidebar> & { user: AuthenticatedUser | null }) {
  const checkIfAdmin = () => {
    if (!props.user) {
      return false;
    }

    return props.user.role.toLowerCase() === "admin";
  };

  return (
    <Sidebar variant={"floating"} collapsible="offcanvas" {...props}>
      <SidebarHeader>
        <TeamSwitcher />
      </SidebarHeader>
      <SidebarContent>
        {checkIfAdmin() && <AdminNav items={data.navMain} />}
        <NavProjects projects={data.projects} />
      </SidebarContent>
      <SidebarFooter>
        {props?.user && <NavUser user={props.user} />}
        {!props?.user && <UnauthUser />}
        <AppVersion />
      </SidebarFooter>
      <SidebarRail />
    </Sidebar>
  );
}
